import { CSSProperties } from "react";
import * as typeStyles from "@clockwise/web-commons/src/styles/type.styles";
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";

const backgroundColor = greys.paleGrey;
const borderRadius = 3;
const padding = 10;

export const suggestion: CSSProperties = {
  backgroundColor,
  borderRadius,
  padding,
  marginTop: 10,
  lineHeight: 1.4,
  cursor: "pointer",
  fontSize: 14,
  fontFamily: typeStyles.fontFamilySans,
  border: `2px solid ${backgroundColor}`,
};

export const suggestionHovered: CSSProperties = {
  ...suggestion,
  backgroundColor: greys.cloudyBlue,
  border: `2px solid ${greys.cloudyBlue}`,
};

export const suggestionHighlighted: CSSProperties = {
  ...suggestion,
  border: `2px solid ${colors.green.lighter}`,
};

export const checkIcon = {
  style: {
    height: 18,
    width: 18,
    position: "absolute",
    right: 10,
  } as CSSProperties,
  htmlColor: colors.green.darker,
};

export const tags: CSSProperties = {
  fontSize: 12,
  lineHeight: 2,
  fontWeight: 600,
  fontFamily: typeStyles.fontFamily,
};

export const best: CSSProperties = {
  color: colors.green.darker,
};

export const date: CSSProperties = {
  fontSize: 14,
  lineHeight: 1.4,
  color: greys.darkestGrey,
};

export const score: CSSProperties = {
  fontSize: 14,
  lineHeight: 1.4,
  color: greys.darkestGrey,
};

export const stat: CSSProperties = {
  fontWeight: 600,
};

export const room: CSSProperties = {
  marginTop: 3,
  fontSize: 12,
  lineHeight: 1.4,
  color: greys.slate,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

export const businessIcon = {
  style: {
    height: 18,
    width: 18,
    marginRight: 10,
    display: "flex",
    flexShrink: 0,
  } as CSSProperties,
  htmlColor: greys.slate,
};

// SuggestedTimeRescheduler
export const actionButtonContainer: CSSProperties = {
  padding: `0 ${padding}px ${padding}px ${padding}px`,
  borderBottomLeftRadius: borderRadius,
  borderBottomRightRadius: borderRadius,
  backgroundColor: suggestionHovered.backgroundColor,
};

export const actionButton: CSSProperties = {
  display: "block",
  boxShadow: "none",
};

export const savingProgress: CSSProperties = {
  backgroundColor: "transparent",
  position: "relative",
  marginTop: 10,
};

export const warning: CSSProperties = {
  marginTop: 5,
  fontSize: 12,
  lineHeight: 1.4,
  color: colors.peach.darker,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};
